import React, { useEffect, useState } from "react";
import { BROKER_REVIEW_STAGE, brokerPreviewUrl, canonicalStage } from "../../services/brokerReview";
import envVariables from "../../data/envVariables";
import Button from "../ui/Button";
import { isDealPreAvinode } from "../../utilities/settings";

const PortalSalesStageBasedCtas = ({ deal, firstLeg, onShowOptions }) => {
    const [linkCopied, setLinkCopied] = useState(false);
    const legId = deal.daM_Ref;
    const pricesUrl = `${envVariables.documentBase}/prices?lo=${legId}&currency=6`;
    const builderUrl = `${envVariables.documentBase}/QuoteBuilder?lo=${legId}&currency=6&regenerate=true`;

    const avinodeUrl = firstLeg.quotes ?? "";
    const downloadQuoteBriefUrl = `${envVariables.documentBase}/QuotebuilderDownload/download-quotebrief?lo=${legId}`;
    const downloadInvoiceUrl = `${envVariables.documentBase}/api/invoice/download-invoice-jsr?legId=${legId}`;
    const quotePageUrl = `/quote?lo=${legId}`;
    const contractUrl = deal.contract_link;
    const contractDownloadUrl = deal.download_contract_public;

    const paymentUrl = deal.payment_Page_URL;

    useEffect(() => {
        //console.log(deal)
    }, [deal, firstLeg]);

    const openPricesPage = () => {
        window.open(pricesUrl, "_blank");
    };

    const openQuoteBuilder = () => {
        window.open(builderUrl, "_blank");
    };

    const openOptionsPage = () => {
        window.open(avinodeUrl);
    };

    const openInvoiceDL = () => {
        window.open(downloadInvoiceUrl, "_blank");
    };

    const openContractPdf = () => {
        window.open(contractDownloadUrl, "_blank");
    };

    const openContractPage = () => {
        window.open(contractUrl, "_blank");
    };

    const openQuotePage = () => {
        window.open(quotePageUrl, "_blank");
    };

    const openQuotePdf = () => {
        window.open(downloadQuoteBriefUrl, "_blank");
    };

    const openPaymentPage = () => {
        window.open(paymentUrl, "_blank");
    };

    const brokerLink = brokerPreviewUrl(deal.id);

    const copyBrokerLink = async () => {
        try {
            await navigator.clipboard.writeText(brokerLink);
            setLinkCopied(true);
            setTimeout(() => setLinkCopied(false), 2000);
        } catch {
            window.prompt("Copy the broker link:", brokerLink);
        }
    };

    // Determine which CTAs to show based on deal stage
    const getVisibleCtas = () => {
        const stage = canonicalStage(deal?.stage);
        const ctas = {
            showMarketplace: false,
            showPricesPage: false,
            showQuoteBuilder: false,
            showPreviewQuote: false,
            showQuotePdf: false,
            showQuotePage: false,
            showContractPdf: false,
            showContractPage: false,
            showInvoicePdf: false,
            showPaymentPage: false,
            showBrokerLink: false,
        };

        if (isDealPreAvinode(deal)) {
            return ctas;
        }

        switch (stage) {
            case "Ready for quote":
                ctas.showMarketplace = true;
                break;

            case "Out to market":
                ctas.showMarketplace = true;
                ctas.showPricesPage = true;
                ctas.showQuoteBuilder = true;
                ctas.showPreviewQuote = true;
                break;

            case BROKER_REVIEW_STAGE:
                ctas.showMarketplace = true;
                ctas.showPricesPage = true;
                ctas.showQuoteBuilder = true;
                ctas.showPreviewQuote = true;
                ctas.showBrokerLink = true;
                break;

            case "Quoted":
            case "Contract requested":
                ctas.showMarketplace = true;
                ctas.showPricesPage = true;
                ctas.showQuoteBuilder = true;
                ctas.showPreviewQuote = true;
                ctas.showQuotePdf = true;
                ctas.showQuotePage = true;
                break;

            case "Contract sent":
                ctas.showQuoteBuilder = true;
                ctas.showPreviewQuote = true;
                ctas.showQuotePdf = true;
                ctas.showQuotePage = true;
                ctas.showContractPdf = true;
                ctas.showContractPage = true;
                ctas.showInvoicePdf = true;
                break;

            case "Contract signed":
                ctas.showQuoteBuilder = true;
                ctas.showContractPdf = true;
                ctas.showInvoicePdf = true;
                ctas.showPaymentPage = true;
                break;

            default:
                break;
        }

        return ctas;
    };

    const visibleCtas = getVisibleCtas();

    return (
        <>
            <div className="portal-cta-grid">
                {visibleCtas.showMarketplace && firstLeg?.quotes && (
                    <Button classNames={["button button--secondary"]} onClick={openOptionsPage}>
                        Marketplace
                    </Button>
                )}
                {visibleCtas.showPricesPage && (
                    <Button classNames={["button button--secondary"]} onClick={openPricesPage}>
                        Prices page
                    </Button>
                )}
                {visibleCtas.showQuoteBuilder && (
                    <Button classNames={["button button--secondary"]} onClick={openQuoteBuilder}>
                        Quote builder
                    </Button>
                )}
                {visibleCtas.showPreviewQuote && (
                    <Button classNames={["button button--secondary"]} onClick={onShowOptions}>
                        Preview Quote
                    </Button>
                )}
                {visibleCtas.showBrokerLink && (
                    <>
                        <Button classNames={["button button--secondary"]} onClick={copyBrokerLink}>
                            {linkCopied ? "Link copied" : "Copy broker link"}
                        </Button>
                    </>
                )}
                {visibleCtas.showQuotePdf && (
                    <Button classNames={["button button--secondary"]} onClick={openQuotePdf}>
                        Quote PDF
                    </Button>
                )}
                {visibleCtas.showQuotePage && (
                    <Button classNames={["button button--secondary"]} onClick={openQuotePage}>
                        Quote page
                    </Button>
                )}
                {visibleCtas.showContractPdf && contractDownloadUrl && (
                    <Button classNames={["button button--secondary"]} onClick={openContractPdf}>
                        Contract PDF
                    </Button>
                )}
                {visibleCtas.showContractPage && contractUrl && (
                    <Button classNames={["button button--secondary"]} onClick={openContractPage}>
                        Contract Page
                    </Button>
                )}
                {visibleCtas.showInvoicePdf && (
                    <Button classNames={["button button--secondary"]} onClick={openInvoiceDL}>
                        Invoice PDF
                    </Button>
                )}
                {visibleCtas.showPaymentPage && paymentUrl && (
                    <Button classNames={["button button--secondary"]} onClick={openPaymentPage}>
                        Payment page
                    </Button>
                )}
            </div>
        </>
    );
};

export default PortalSalesStageBasedCtas;
